<template>
  <header class="site-header">
    <div class="site-header__inner">
      <a :href="m.website + '/'" class="site-header__logo">
        <img :src="m.logo" alt="Tapes To Digital" height="40" />
      </a>
      <div class="site-header__actions">
        <a :href="m.phoneHref" class="site-header__phone">{{ m.phoneDisplay }}</a>
        <a
          :href="waHref"
          target="_blank"
          rel="noopener"
          data-wa-source="order_header"
          class="site-header__wa"
          aria-label="Chat on WhatsApp"
          @click="onWhatsapp"
        >
          <WhatsAppIcon :size="20" />
          <span class="site-header__wa-text">Chat on WhatsApp</span>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import WhatsAppIcon from "./WhatsAppIcon.vue";
import { market } from "@/utils/market";
import { waLink, trackWhatsappClick } from "@/utils/whatsapp";

export default {
  components: { WhatsAppIcon },
  data: () => ({
    m: market(),
  }),
  computed: {
    waHref() {
      return waLink("Hi! I have a question about my order.");
    },
  },
  methods: {
    onWhatsapp() {
      trackWhatsappClick("order_header", { step: this.$route.name || null });
    },
  },
};
</script>

<style scoped>
.site-header {
  background: #ffffff;
  border-bottom: 1px solid #e3e7ea;
}
.site-header__inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.site-header__logo {
  display: flex;
  align-items: center;
}
.site-header__logo img {
  height: 40px;
  width: auto;
  display: block;
}
.site-header__actions {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  font-weight: 600;
}
.site-header__phone {
  text-decoration: none;
  color: #1e1e1e !important;
  white-space: nowrap;
}
.site-header__wa {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #0b141a !important;
  background: #25d366;
  padding: 0 16px;
  height: 44px;
  border-radius: 5px;
  font-weight: 700;
  white-space: nowrap;
}
@media (max-width: 600px) {
  .site-header__inner {
    padding: 0 16px;
    height: 60px;
  }
  .site-header__logo img {
    height: 32px;
  }
  .site-header__phone {
    display: none;
  }
  .site-header__wa {
    width: 44px;
    padding: 0;
    justify-content: center;
  }
  .site-header__wa-text {
    display: none;
  }
}
</style>
